import React from 'react';
import Main from './components/main';
import Sub from './components/sub';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Main} />
        <Route path="/item" component={Sub} />
      </Switch>
    </Router>
  );
}

export default App;
